import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { BulkFilesConfirmation } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

async function confirmSavedFiles(
  bulkFilesConfirmations: BulkFilesConfirmation[]
) {
  const headers = {
    'Content-Type': 'application/json',
  };

  return await restFactory.post(
    `/dj/api/v1/file/saved_files_confirmation/`,
    bulkFilesConfirmations,
    headers
  );
}

type UseConfirmSavedFilesProps = {
  onClose?: () => void;
};

export function useConfirmSavedFiles({
  onClose,
}: UseConfirmSavedFilesProps = {}) {
  return useMutation(confirmSavedFiles, {
    onSuccess: () => {
      onClose?.();
      toast.success('Files saved.');
    },
    onError: () => {
      toast.error('Error saving files.');
    },
  });
}
